import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CategoryService } from '../_services/category.service';
import { ShopDto } from '../profile/shop-dto';

@Component({
    selector: 'app-category-detail',
    templateUrl: './category-detail.component.html',
    styleUrls: ['./category-detail.component.css'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})
export class CategoryDetailComponent implements OnInit {
  id: number;
  categoryname: string;
  private sub: any;
  public category: ShopDto;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private categoryService: CategoryService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['categoryId'];

      this.categoryService.getCategory(this.id).subscribe(
        data => {
          this.category = JSON.parse(data);
          this.categoryname = this.category.name;
          this.cdr.detectChanges();
        },
        err => {
          console.error('Er is een fout opgetreden');
        }
      );
    });
  }

  deleteCategory(id): void {
    this.categoryService.deleteCategory(id).subscribe(
      data => {
        this.router.navigate(['/profile', { 'showWinkel': true }]);
      },
      err => {
        console.error('Er is iets fout gegaan');
      }
    );
  }
}
